<template>
	<div>
		<el-dialog title="添加" width="600px" class="icon-dialog" :visible.sync="show" @open="open" :before-close="closeForm" append-to-body>
			<el-form :size="size" ref="form" :model="form" :rules="rules" :label-width="$store.getters.device !== 'mobile'?'16%':'90px'">
			<el-form-item label="题目类型：">
                <el-select  @change="changetype" style="width: 100px;" size="small" v-model="form.type" placeholder="请选择">
                    <el-option v-for="type in type" :label="type.key" :value="type.value" :key="type.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="科目类别：">
                <el-select  @change="changesubject"  style="width: 100px;" size="small" v-model="form.subject" placeholder="请选择">
                    <el-option v-for="type in subject" :label="type.key" :value="type.value" :key="type.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="题目分类：">
                <el-checkbox-group v-model="form.classify" >
                  <el-checkbox-button style="margin: 4px;" @change="val=>change(val,item)"  :label="item.pcid" v-for="item in classify" :key="item.pcid">{{ item.classify }}</el-checkbox-button>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="json：">
                <el-input  type="textarea" v-model="form.json"></el-input>
            </el-form-item>
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button :size="size" :loading="loading" type="primary" @click="submit" >
					<span v-if="!loading">确 定</span>
					<span v-else>提 交 中...</span>
				</el-button>
				<el-button :size="size" @click="closeForm">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
 import { getadd,getclassify } from '../../api/userMG';
export default {
	name:'Add',
	components: {
	},
	props: {
		show: {
			type: Boolean,
			default: false
		},
		size: {
			type: String,
			default: 'small'
		},
	},
	data(){
		return {
            subject: [
                { key: '科目一', value: 0 },
                { key: '科目四', value: 3 },
            ],
            type: [
                { key: '小车', value: 0 },
                { key: '货车', value: 1 },
                { key: '客车', value: 2 },
                { key: '摩托车', value: 3 },
            ],
			form: {
                type:0,
                subject:0,
                json:'',
                classify:[]
			},
            classify:[],
			role_ids:[],
			loading:false,
			lists:[],
			pcidlist:[],
			rules: {
			}
		}
	},
	watch:{
		form(val){
			console.log(val,'+++++++++');
		},
		show(val){
			if(val){
                this.getclass()
			}
		}
	},
	methods: {
		getclass(){
			getclassify(this.form).then(res=>{
                    console.log(res);
                    this.classify = res.classify
                })
		},
		open(){
		},
		//题目类型改变
		changetype(e){
			this.form.type = e
			this.getclass()
		},
				//题目类型改变
		changesubject(e){
			this.form.subject = e
			this.getclass()
		},
		submit(){
			console.log(this.form);
			this.$refs['form'].validate(valid => {
				if(valid) {
					this.loading = true
					getadd(this.form).then(res => {
						console.log(res.code);
						if(res.code == 200){
							this.$message({message: '操作成功', type: 'success'})
							this.$emit('refesh_list')
							this.closeForm()
						}else{
							this.$message({message: res.msg, type: 'error'})
						this.loading = false
						}
					}).catch(()=>{
						this.loading = false
					})
				}
			})
		},
		closeForm(){
			this.$emit('update:show', false)
			this.loading = false
			this.form.classify = []
			this.form.json = ''
			if (this.$refs['form']!==undefined) {
				this.$refs['form'].resetFields()
			}
		},
	}
}
</script>
<style scoped >
</style>



// WEBPACK FOOTER //
// src/views/topic/add.vue